import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRecording } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getRecording = async (
  organisationId: string,
  id: string,
): Promise<PublicRecording> => {
  const response = await axiosClient.get(`${organisationId}/recordings/${id}`);
  return response.data;
};

export const getRecordingQueryKey = (organisationId: string, id: string) => [
  "recording",
  organisationId,
  id,
];

export function useGetRecording(
  { organisationId, id }: { organisationId: string; id: string },
  queryOptions?: Partial<
    UseQueryOptions<PublicRecording, HttpError, PublicRecording, string[]>
  >,
) {
  return useQuery({
    queryKey: getRecordingQueryKey(organisationId, id),
    queryFn: () => getRecording(organisationId, id),
    ...queryOptions,
  });
}
